'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _flickityImagesloaded = require('flickity-imagesloaded');

var _flickityImagesloaded2 = _interopRequireDefault(_flickityImagesloaded);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a new carousel instance.
 * @param {String} selector - DOM selector.
 * @param {object} config - Flickity carousel settings.
 */
/**
 * Carousel
 * ------------------------------------------------------------------------------
 * An example file that contains scripts to function
 *
 * @namespace carousel
 */
exports.default = function (selector, config) {

  /**
   * Instance default settings.
   */
  var defaults = {
    autoPlay: false,
    cellAlign: 'left',
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    initialIndex: 1,
    groupCells: true
  };

  /**
   * Instance settings.
   */
  var settings = (0, _utils.extendDefaults)(defaults, config);

  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    container: document.querySelector(selector),
    pageDots: document.getElementsByClassName('flickity-page-dots'),
    cells: [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(config.cellSelector)))
  };

  /**
   * Instance globals.
   */
  var carousel = {};

  /**
   * Toggle page dots display
   */
  function togglePageDots() {
    var dots = nodeSelectors.pageDots;
    var singleSlide = 1;

    for (var i = 0; i < dots.length; i++) {
      var slidesLength = dots[i].childNodes.length;

      if (slidesLength <= singleSlide) {
        dots[i].style.display = 'none';
      }
    }
  }

  function showPageDots(path) {
    if (window.location.pathname === path) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Initialise carousel component.
   */

  function init() {

    if (nodeSelectors.cells.length <= 1) {
      return;
    }

    carousel = new _flickityImagesloaded2.default(nodeSelectors.container, {
      autoPlay: nodeSelectors.container.getAttribute('data-autoplay'),
      cellSelector: settings.cellSelector,
      cellAlign: settings.cellAlign,
      pageDots: showPageDots('/'),
      prevNextButtons: settings.prevNextButtons,
      wrapAround: settings.wrapAround,
      imagesLoaded: settings.imagesLoaded,
      initialIndex: settings.initialIndex,
      groupCells: settings.groupCells
    });

    togglePageDots();

    flickityFix();
  }

  /**
   * Trigger reload events.
   */
  function reload() {
    carousel.reloadCells();
  }

  /**
   * Trigger resize events.
   */
  function resize() {
    carousel.resize();
  }

  /**
   * Destroy instance.
   */
  function destroy() {
    carousel.destroy();
  }

  function select(index) {
    carousel.select(index);
  }

  /**
    * Resolves a flickity carousel issue happening on iOS 12.0.0+
    */
  function flickityFix() {
    var touchingCarousel = false;
    var touchStartCoords = void 0;
    document.body.addEventListener('touchstart', function (event) {
      if (event.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }
      touchStartCoords = {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
      };
    });
    document.body.addEventListener('touchmove', function (event) {
      if (!(touchingCarousel && event.cancelable)) {
        return;
      }
      var moveVector = {
        x: event.touches[0].pageX - touchStartCoords.x,
        y: event.touches[0].pageY - touchStartCoords.y
      };
      if (Math.abs(moveVector.x) > 7) {
        event.preventDefault();
      }
    }, { passive: false });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init: init,
    reload: reload,
    resize: resize,
    destroy: destroy,
    select: select
  });
};